import { searchboxConfig } from '../defaultConfig'

export enum Projects {
  orama = 'orama',
  recipes = 'recipes',
  videogames = 'videogames'
}

export interface Project {
  framework: string
  cloud: boolean
  colorScheme: 'light' | 'dark' | 'system'
  theme: 'primary' | 'secondary' | undefined
  themeConfig: typeof searchboxConfig.ui.theme
  cloudConfig?: {
    url: string
    key: string
  }
  facetProperty?: string
  keepOpen?: boolean
  resultsMap: {
    title?: string
    description?: string
    section?: string
    category?: string
    path?: string
  }
}

const config: Record<Projects, Project> = {
  recipes: {
    framework: 'react',
    cloud: true,
    colorScheme: 'system',
    theme: 'secondary',
    themeConfig: searchboxConfig.ui.theme,
    cloudConfig: {
      url: 'https://cloud.orama.run/v1/indexes/recipes-m7w9mm',
      key: 'yl2JSnjLNBV6FVfUWEyadpjFr6KzPiDR'
    },
    facetProperty: 'category',
    resultsMap: {
      title: 'title',
      description: 'title',
      section: 'category',
      category: 'category',
      path: 'path'
    },
    keepOpen: undefined
  },
  orama: {
    framework: 'react',
    cloud: true,
    colorScheme: 'system',
    theme: 'primary',
    // FIX-ME: We are wrongly using this theme as Default Theme on Dashboard application. Please don't change!!!
    themeConfig: searchboxConfig.ui.theme,
    keepOpen: undefined,
    cloudConfig: {
      url: 'https://cloud.orama.run/v1/indexes/orama-docs-pgjign',
      key: '6kHcoevr3zkbBmC2hHqlcNQrOgejS4ds'
    },
    facetProperty: 'category',
    resultsMap: {
      title: 'title',
      description: 'title',
      section: 'section',
      category: 'category',
      path: 'path'
    }
  },
  videogames: {
    framework: 'react',
    cloud: true,
    colorScheme: 'system',
    theme: 'primary',
    themeConfig: searchboxConfig.ui.theme,
    keepOpen: undefined,
    cloudConfig: {
      url: 'https://cloud.orama.foo/v1/indexes/videogames-rk139h',
      key: 'WL7pKdEqCTPf3G2412x8ecneqVbnkklr'
    },
    resultsMap: {
      title: 'title',
      description: 'description',
      path: 'url'
    }
  }
}

export const defaultConfig = config.orama

export default config
